import React from "react";

interface PathBreadcrumbProps {
  initialPath: string; // 예: "/Users/harrison.kim/Downloads/"
  currentPath: string; // 예: "/Users/harrison.kim/Downloads/brown/green"
  onClick: (path: string) => void; // 경로 클릭 시 호출
}

const PathBreadcrumb: React.FC<PathBreadcrumbProps> = ({
  initialPath,
  currentPath,
  onClick,
}) => {
  if (!initialPath) return null;

  // currentPath에서 initialPath 이후의 부분만 분리
  const subPath = currentPath.replace(initialPath, "").replace(/^\/+/, ""); // 예: "brown/green"
  const segments = subPath ? subPath.split("/") : [];

  // 각 segment에 대해 누적 경로 생성
  const paths = segments.map((seg, idx) => {
    const rawPath = `${initialPath}${segments.slice(0, idx + 1).join("/")}`;
    const fullPath = rawPath.replace(/\/+$/, ""); // ✅ 마지막 `/` 제거 (하위 경로에는 없어야 함)
    return { label: seg, fullPath };
  });

  return (
    <div className="path-name">
      <span
        style={{ cursor: "pointer", textDecoration: "underline" }}
        onClick={() => onClick(initialPath)} // ✅ 최초 경로는 그대로 사용
      >
        {initialPath}
      </span>
      {paths.map((seg) => (
        <span key={seg.fullPath}>
          <span style={{ margin: "0 1.2rem" }}>&gt;</span>
          <span
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() => onClick(seg.fullPath)}
          >
            {seg.label}
          </span>
        </span>
      ))}
    </div>
  );
};

export default PathBreadcrumb;
